import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Department } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchDepartments = createAsyncThunk(
	"departments/fetch",
	apiGet<Department[]>(
		(authConfig) => authConfig.MS_GRAPH_API_ENDPOINTS.GET_DEPARTMENTS(),
		[SCOPES.GRAPH_READ],
	),
);
